module.exports = "https://www.gc-qa.gnp.com.mx/4ea109f8f376be23261d2c91cd29a291.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/historico-pagos/2.png
// module id = 1035
// module chunks = 0 1